import React from "react";
import { useParams } from "react-router-dom";
import { useGetExercisesId } from "../../api/useProducts/useExercises";
import { Sidebar } from "../../components";
import ReactPlayer from "react-player";
import Loader from "../../components/Loader";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";

// Define ExerciseDetail Component
const ExerciseDetail = () => {
  const { exerciseId } = useParams();
  const { exerciseData, exerciseLoading, exerciseRefetch } = useGetExercisesId(
    Number(exerciseId)
  );

  // Refetch exercise data whenever exerciseId changes
  React.useEffect(() => {
    exerciseRefetch();
  }, [exerciseId]);

  const breadcrumbItems = [
    { title: "Exercises", link: "exercises" },
    { title: "Detail " },
  ];
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      {exerciseLoading ? (
        <div className="h-[80vh] flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div className="mt-3 break-all">
          {/* Exercise Title */}
          <h1 className="text-3xl font-bold">{exerciseData?.title}</h1>

          {/* Exercise Video */}
          {exerciseData?.video && (
            <div className="mt-5">
              <div className="relative max-w-full  border-[1.5px] rounded-2xl overflow-hidden">
                <ReactPlayer
                  url={exerciseData?.video}
                  controls={true}
                  width="100%"
                  style={{ objectFit: "cover" }}
                  height="420px"
                  playing={false} // Start the video paused
                  light={false} // Don't show a thumbnail preview (you can set it to true if you'd like)
                />
              </div>
            </div>
          )}
          <br />
          <div className="border-b-2 flex">
            <span className="border-b-[3.5px] border-darkCyan ms-4 font-medium px-3 pb-2 translate-y-[2px]">
              Overview
            </span>
          </div>

          <div className="mt-5 space-y-2 border-b-2 pb-4">
            <p>
              <span className="font-medium">Sets:</span>{" "}
              {exerciseData?.sets || "N/A"}
            </p>
            <p>
              <span className="font-medium">Duration:</span>{" "}
              {exerciseData?.duration || "N/A"}
            </p>
            <p>
              <span className="font-medium">Reps:</span>{" "}
              {exerciseData?.reps || "N/A"}
            </p>
            <p>
              <span className="font-medium">Category:</span>{" "}
              {exerciseData?.category || "N/A"}
            </p>
          </div>

          {/* Category */}
          {/* {exerciseData?.category && (
          <div className="mt-5">
            <p>
              <strong>Category:</strong> {exerciseData?.category}
            </p>
          </div>
        )} */}

          {/* Instructions */}
          {exerciseData?.instructions && (
            <div className="mt-5">
              <h3 className="font-medium">Description</h3>
              <br />
              <div className=" text-base ">
                <div
                  className="mt-"
                  dangerouslySetInnerHTML={{
                    __html: exerciseData?.instructions,
                  }}
                />
              </div>
            </div>
          )}

          {/* Images */}
          {exerciseData?.exerciseImages &&
            exerciseData?.exerciseImages?.length > 0 && (
              <div className="mt-5">
                <h3 className="font-medium">Exercise Images</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                  {exerciseData?.exerciseImages?.map((image) => (
                    <img
                      key={image?.id}
                      src={image?.image}
                      alt={`Exercise Image ${image?.id}`}
                      className="w-full	 rounded-lg shadow-lg"
                    />
                  ))}
                </div>
              </div>
            )}
        </div>
      )}
    </Sidebar>
  );
};

export default ExerciseDetail;
